module.exports = __webpack_public_path__ + "static/media/ic-gridview.694625d3.svg";